module.exports = __webpack_public_path__ + "img/tiktok.0bd79cc9.svg";